import React from 'react';
import ChatInput from '../atoms/ChatInput';
import Button from '../atoms/Button';

const ChatInputArea = ({ 
  inputValue, 
  onInputChange, 
  onSend, 
  disabled = false,
  isLoading = false,
  placeholder = "Type your message...",
  gradientFrom = "#831f82",
  gradientTo = "#6b1a6b"
}) => {
  const canSend = inputValue.trim() && !disabled && !isLoading;

  return (
    <div className="p-4 bg-white border-t border-gray-200">
      <div className="flex items-center space-x-3">
        <ChatInput
          value={inputValue}
          onChange={onInputChange}
          onSend={canSend ? onSend : () => {}}
          disabled={disabled}
          placeholder={placeholder}
        />
        <button
          onClick={onSend}
          disabled={!canSend}
          className="p-3 text-white rounded-xl hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105 disabled:transform-none flex items-center justify-center min-w-[48px] h-[52px]"
          style={{ background: `linear-gradient(to right, ${gradientFrom}, ${gradientTo})` }}
        >
          {isLoading ? (
            <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
          ) : (
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
            </svg>
          )}
        </button>
      </div>
      <div className="flex items-center justify-between mt-2 text-xs text-gray-500">
        <span>* Press Enter to send, Shift+Enter for new line *</span>
        <span className="text-gray-400">
          {inputValue.length}/500
        </span>
      </div>
    </div>
  );
};

export default ChatInputArea;